<template>
  <div class="mk-size-input">
    <div
      class="mk-size-input__label"
    >
      {{label}}
    </div>
    <div class="mk-size-input__inputs">
      <select
        v-model="valueInDeg"
        @focus="focusCallback"
        class="mk-size-input__inputs__value"
      >
        <option value="90">90°</option>
        <option value="60">60°</option>
        <option value="45">45°</option>
        <option value="30">30°</option>
      </select>
    </div>
  </div>
</template>

<script>
/**
 * ANGLE INPUT
 * @author David <david.prenninger@gmx.de>
 *
 * Input component to provide a angle selection between 30, 45, 60, 90 degree.
 */
export default {
  name: 'AngleInput',
  props: {
    label: String,
    focusCallback: Function,
    updateValue: Function,
    value: Number,
  },
  computed: {
    valueInDeg: {
      get() {
        return this.value;
      },
      set(value) {
        this.updateValue(Number(value));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-size-input {
  border: 1px solid $c_primary_light;
  margin: 10px 0;
  display: flex;
  align-items: center;
  border-radius: $br_md;
  overflow: hidden;
  font-size: 14px;

  &__label {
    flex: 0 0 140px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: $c_accent;
    color: $c_white;
    padding: 10px;
    font-weight: 500;
  }

  &__inputs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    margin: 0;

    &__value {
      text-align: center;
      border: none;
      font-weight: 500;
      width: 50%;
      border:0;
      background:none;
      -webkit-appearance: none;
      margin: 0;
      background-repeat: no-repeat;
      background-position: right;
    }
    &__metric {
      text-align: center;
      border: none;
    }
  }
}

</style>
